import { useCurrencySymbol } from "hooks";

type CurrencyType = "USD" | "GBP" | "UNKNOWN";

/**
 * @deprecated returns code not name, use useCurrencyCode instead
 */
export const useCurrencyName = (): CurrencyType => {
  const symbol = useCurrencySymbol();
  switch (symbol) {
    case "$":
      return "USD";
    case "£":
      return "GBP";
    default:
      return "UNKNOWN";
  }
};
